import { useEffect, useState } from "react";
import { useFeedback } from "../Contexts/FeedbackContext";
import {
  addAssignment,
  deleteAssignment,
  fetchAssignments,
} from "../services/assignmentService";
import { ERROR_UPDATE, SUCCESS_UPDATE } from "../constants/feedbacks";

export function useExaminerManager(examinerId) {
  const { showFeedback } = useFeedback();
  const [juryHistory, setJuryHistory] = useState([]);
  const [selectedJury, setSelectedJury] = useState([]);
  useEffect(() => {
    fetchAssignments(examinerId)
      .then((response) => {
        const data = response.data;

        const transformedData = data.map((item) => ({
          groupId: item.batch.id,
          juryId: item.jury.id,
        }));
        setSelectedJury(transformedData);
        setJuryHistory(transformedData);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [examinerId]);

  function onSubmit() {
    const deletions = juryHistory.filter(
      (jh) =>
        !selectedJury.some(
          (sj) => sj.groupId === jh.groupId && sj.juryId === jh.juryId
        )
    );
    const additions = selectedJury.filter(
      (sj) =>
        !juryHistory.some(
          (jh) => jh.groupId === sj.groupId && jh.juryId === parseInt(sj.juryId)
        )
    );

    const postRequests = additions.map((item) =>
      addAssignment(examinerId, item.groupId, item.juryId)
    );

    const deleteRequests = deletions.map((item) =>
      deleteAssignment(examinerId, item.groupId, item.juryId)
    );

    Promise.all([...postRequests, ...deleteRequests])
      .then(() => {
        showFeedback(SUCCESS_UPDATE, true);
        setJuryHistory(selectedJury);
      })
      .catch((error) => {
        showFeedback(ERROR_UPDATE, false);
        console.error(error);
      });
  }

  return { onSubmit, selectedJury, setSelectedJury };
}
